class Form {
  constructor() {
    this.form = null;
    this.inputs = null;
    this.constraints = {};

    this.validate();
    //this.initSelectbox();

    if (document.querySelector(".input-toggle")) {
      this.toggleInputs();
      this.replaceDateFields();
      this.hideDateEndFieldOnCheckboxChecked();
    }
  }

  validate() {
    const _self = this;
    this.form = document.querySelector(".form-application") || null;

    if (!this.form) return;

    this.form.setAttribute("novalidate", "novalidate");
    this.inputs = document.querySelectorAll("input, textarea, select");

    this.inputs.forEach((ff) => {
      if (ff.required && ff.name) {
        // Set defaults
        this.constraints[ff.name] = {};

        // Set messages
        let errorMessageTxt = ff.getAttribute("data-error-message");
        if (errorMessageTxt) {
          this.constraints[ff.name]["presence"] = {};
          this.constraints[ff.name]["presence"]["message"] =
            "^" + errorMessageTxt;
        } else {
          this.constraints[ff.name]["presence"] = true;
        }

        // Settings mail
        if (ff.type === "email") {
          this.constraints[ff.name]["email"] = {};
          this.constraints[ff.name]["email"]["message"] = "^" + errorMessageTxt;
        }

        // Settings phone
        if (ff.type === "tel") {
          if (ff.pattern) {
            this.constraints[ff.name]["format"] = {};
            this.constraints[ff.name]["format"]["pattern"] = ff.pattern;
            this.constraints[ff.name]["format"]["message"] =
              "^" + errorMessageTxt;
          }

          if (ff.minLength) {
            this.constraints[ff.name]["length"] = {
              minimum: ff.minLength || 1,
              message: "^" + errorMessageTxt,
            };
          }
        }

        // Settings checkbox
        if (ff.type === "checkbox") {
          this.constraints[ff.name]["inclusion"] = {};
          this.constraints[ff.name]["inclusion"]["within"] = [
            "datenschutz",
            true,
          ];
          this.constraints[ff.name]["inclusion"]["message"] =
            "^" + errorMessageTxt;
        }
      }
    });

    this.form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      this.handleFormSubmit(this.form);
    });

    for (var i = 0; i < this.inputs.length; ++i) {
      this.inputs.item(i).addEventListener("change", function (ev) {
        let errors = validate(_self.form, _self.constraints) || {};
        _self.showErrorsForInput(this, errors[this.name]);
      });
    }

    this.handleFormSubmit = (form, input) => {
      let errors = validate(this.form, this.constraints);
      this.showErrors(this.form, errors || {});

      if (document.querySelector("#g-recaptcha-response").value) {
        $("#g-recaptcha-error").hide();
      } else {
        $(".g-recaptcha").append(
          '<div class="error-msg text-danger" id="g-recaptcha-error">Das reCAPTCHA wurde nicht bestätigt!</div>'
        );
      }

      if (!errors && document.querySelector("#g-recaptcha-response").value) {
        this.form.submit();
      }
    };

    this.showErrors = (form, errors) => {
      let fields = form.querySelectorAll(
        "input[name][required], select[name][required], checkbox[name][required], textarea[name][required]"
      );
      fields.forEach((input) => {
        this.showErrorsForInput(input, errors && errors[input.name]);
      });
    };

    this.showErrorsForInput = (input, errors) => {
      let formGroup = this.closestParent(input.parentNode, "form-group"),
        messages = formGroup.querySelector(".error-msg");

      this.resetFormGroup(formGroup);

      if (errors) {
        formGroup.classList.add("is-error");
        errors.forEach((error) => {
          this.addError(messages, error);
        });
      } else {
        formGroup.classList.add("is-success");
      }
    };

    this.closestParent = (child, className) => {
      if (!child || child == document) {
        return null;
      }
      if (child.classList.contains(className)) {
        return child;
      } else {
        return this.closestParent(child.parentNode, className);
      }
    };

    this.resetFormGroup = (formGroup) => {
      formGroup.classList.remove("is-error");
      formGroup.classList.remove("is-success");

      formGroup.querySelectorAll(".help-block.error").forEach((el) => {
        el.parentNode.removeChild(el);
      });
    };

    // Adds the specified error with the following markup
    // <p class="help-block error">[message]</p>
    this.addError = (messages, error) => {
      let block = document.createElement("p");
      block.classList.add("help-block");
      block.classList.add("error");
      block.innerText = error;
      if (messages) messages.appendChild(block);
    };

    this.showSuccess = () => {
      alert("Success!");
    };
  }

  initSelectbox() {
    $(".form-selectbox").selectric({
      onClose: (select) => {
        setTimeout(() => {
          let errors = validate(this.form, this.constraints) || {};
          this.showErrorsForInput(select, errors[select.name]);
        }, 50);
      },
    });
  }

  /**
   * @desc func for switching input type to date on click
   */
  replaceDateFields = () => {
    let dateFields = Array.from(
      document.querySelectorAll(
        'input[placeholder=""], input[placeholder="*"], input[placeholder=""], input[placeholder="*"]'
      )
    );

    dateFields.forEach((field) => {
      field.addEventListener("click", () => {
        if (field === document.activeElement) {
          field.setAttribute("type", "date");
        }

        if (!field.parentNode.querySelector("label")) {
          let label = document.createElement("label");
          label.classList.add("datepicker-label");
          label.innerText = field.getAttribute("placeholder");
          field.parentNode.insertBefore(label, field);
        }
      });
    });
  };

  /**
   * @desc func for toggling input fields of carrer
   */
  toggleInputs = () => {
    let inputs = Array.from(document.querySelectorAll(".input-toggle"));

    this.hideInputs(inputs);
    this.addShowInputsButton(inputs);
    this.showInputsOnClick();
  };

  /**
   * @desc func for adding show input button to DOM
   * @param inputs
   */
  addShowInputsButton = (inputs) => {
    let lastInput = inputs.pop(),
      showInputsButton,
      howInputsWrapper;

    showInputsButton = document.createElement("button");
    showInputsButton.classList.add("input-toggle-button");
    showInputsButton.innerText = "Tätigkeit hinzufügen";

    howInputsWrapper = document.createElement("div");
    howInputsWrapper.classList.add("col-md-12");
    howInputsWrapper.classList.add("toggle-container");
    howInputsWrapper.appendChild(showInputsButton);

    this.insertAfter(howInputsWrapper, lastInput);
  };

  /**
   * @desc func for removing show input button from DOM
   * @param toggleButton
   */
  removeShowInputsButton = (toggleButton) => {
    toggleButton.remove();
  };

  /**
   * @desc func for getting all hidden inputs
   * @returns {T[]}
   */
  getHiddenInputs = () => {
    return Array.from(document.querySelectorAll(".input-toggle.hidden"));
  };

  /**
   * @desc func for getting all the non hidden inputs
   * @returns {T[]}
   */
  getNotHiddenInputs = () => {
    return Array.from(document.querySelectorAll(".input-toggle:not(.hidden)"));
  };

  /**
   * @desc func for hiding all field lines except first line
   * @param inputs
   */
  hideInputs = (inputs) => {
    let iterator = 0;

    inputs.forEach((input) => {
      if (iterator >= 4) {
        input.classList.add("hidden");
      }
      iterator++;
    });
  };

  /**
   * @desc func for showing next hidden input line on button click
   */
  showInputsOnClick = () => {
    let toggleButton = document.querySelector(".input-toggle-button"),
      toogleContainer = document.querySelector(".toggle-container"),
      hiddenInputs,
      removeButton,
      iterator;

    toggleButton.addEventListener("click", (e) => {
      e.preventDefault();

      iterator = 0;
      hiddenInputs = this.getHiddenInputs();
      hiddenInputs.forEach((input) => {
        if (iterator < 4) {
          input.classList.remove("hidden");
        }
        iterator++;
      });

      hiddenInputs = this.getHiddenInputs();
      if (hiddenInputs.length === 0) {
        this.removeShowInputsButton(toggleButton);
      } else {
        if (
          !document.body.contains(
            document.querySelector(".input-remove-button")
          )
        ) {
          removeButton = document.createElement("button");
          removeButton.classList.add("input-remove-button");
          removeButton.innerText = "Letzte Tätigkeit entfernen";
          toogleContainer.appendChild(removeButton);
          this.removeInputsOnClick();
        }
      }
    });
  };

  /**
   * @desc func for removing last shown input line on button click
   */
  removeInputsOnClick = () => {
    let toggleButton = document.querySelector(".input-remove-button"),
      toogleContainer = document.querySelector(".toggle-container"),
      notHiddenInputs,
      hiddenInputs,
      showInputsButton,
      iterator;

    toggleButton.addEventListener("click", (e) => {
      e.preventDefault();

      iterator = 1;
      notHiddenInputs = this.getNotHiddenInputs();
      notHiddenInputs.forEach((input) => {
        if (iterator > notHiddenInputs.length - 4) {
          input.classList.add("hidden");
          input.classList.remove("hide");
          Array.from(input.querySelectorAll("input")).forEach((inputNode) => {
            switch (inputNode.type) {
              case "date":
                inputNode.type = "date";
              case "text":
              case "hidden":
                inputNode.value = "";
                break;
              case "checkbox":
                inputNode.checked = false;
            }
          });
          if (notHiddenInputs.length - 4 === 4) {
            toggleButton.remove();
          }
        }
        iterator++;
      });

      hiddenInputs = this.getHiddenInputs();
      if (
        hiddenInputs.length > 0 &&
        !document.body.contains(document.querySelector(".input-toggle-button"))
      ) {
        showInputsButton = document.createElement("button");
        showInputsButton.classList.add("input-toggle-button");
        showInputsButton.innerText = "Tätigkeit hinzufügen";
        toogleContainer.prepend(showInputsButton);
        this.showInputsOnClick();
      }
    });
  };

  /**
   * @desc func for adding element directly after an other element
   * @param newNode
   * @param existingNode
   */
  insertAfter = (newNode, existingNode) => {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  };

  hideDateEndFieldOnCheckboxChecked = () => {
    let checkboxes = document.querySelectorAll(".input-toggle input.add-on");

    Array.from(checkboxes).forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          if (
            checkbox.parentElement.parentElement.parentElement.parentElement
              .previousElementSibling
          )
            checkbox.parentElement.parentElement.parentElement.parentElement.previousElementSibling.classList.add(
              "hide"
            );
        } else {
          if (
            checkbox.parentElement.parentElement.parentElement.parentElement
              .previousElementSibling
          )
            checkbox.parentElement.parentElement.parentElement.parentElement.previousElementSibling.classList.remove(
              "hide"
            );
        }
      });
    });
  };
}

// Init form
$(document).ready(() => {
  new Form();

  // Temporary javascript solution for confirmation button skip
  if ($("#jobApplicationFormConfirm-4237").length > 0) {
    $("#jobApplicationFormConfirm-4237").submit();
  }

  if ($("#GeneralJobApplicationFormConfirm-4215").length > 0) {
    $("#GeneralJobApplicationFormConfirm-4215").submit();
  }

  if ($("#cancallationFormConfirm-4259").length > 0) {
    $("#cancallationFormConfirm-4259").submit();
  }

  if ($("#coursesJobApplicationFormConfirm-5618").length > 0) {
    $("#coursesJobApplicationFormConfirm-5618").submit();
  }

  if ($("#generalWorkshopApplicationFormConfirm-6000").length > 0) {
    $("#generalWorkshopApplicationFormConfirm-6000").submit();
  }

  if ($("#generalSchedulerApplicationFormConfirm-6019").length > 0) {
    $("#generalSchedulerApplicationFormConfirm-6019").submit();
  }

  if ($("#generalCustomersupportApplicationFormConfirm-6038").length > 0) {
    $("#generalCustomersupportApplicationFormConfirm-6038").submit();
  }

  if ($("#generalOperatorApplicationFormConfirm-6057").length > 0) {
    $("#generalOperatorApplicationFormConfirm-6057").submit();
  }

  if ($("#generalItApplicationFormConfirm-6076").length > 0) {
    $("#generalItApplicationFormConfirm-6076").submit();
  }

  if ($("#digitalInformationEventConfirmation-8399").length > 0) {
    $("#digitalInformationEventConfirmation-8399").submit();
  }
});
